module.exports = require('./dist/index');


/*****************
 ** WEBPACK FOOTER
 ** ./~/lokka-transport-http/index.js
 ** module id = 500
 ** module chunks = 0
 **/